import { render, staticRenderFns } from "./card-item-box.vue?vue&type=template&id=e482fd8e&scoped=true"
import script from "./card-item-box.vue?vue&type=script&setup=true&lang=js"
export * from "./card-item-box.vue?vue&type=script&setup=true&lang=js"
import style0 from "./card-item-box.vue?vue&type=style&index=0&id=e482fd8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e482fd8e",
  null
  
)

export default component.exports